export const requiredTextValidator = (fieldName?: string) => ({
  required: fieldName ? `${fieldName}を入力してください` : '入力してください',
  validate: (value: string | undefined | null) =>
    value?.trim() !== '' ||
    (fieldName ? `${fieldName}を入力してください` : '入力してください'),
});

export const emailValidator = {
  required: '入力してください',
  minLength: { value: 3, message: '文字数が短すぎます' },
  pattern: {
    value: /.[^\n\r@\u2028\u2029]*@.+\..+/,
    message: 'メールアドレスを入力してください',
  },
};

export const passwordValidator = {
  required: '入力してください',
  minLength: { value: 8, message: 'パスワードは8文字以上でなければなりません' },
  maxLength: {
    value: 64,
    message: 'パスワードは64文字以内でなければなりません',
  },
};

export const phoneNumberValidator = {
  required: '電話番号を入力してください',
  minLength: { value: 10, message: '電話番号は10文字以上でなければなりません' },
  pattern: {
    value: /^[\d-]+$/,
    message: '電話番号は数字とハイフンのみ許可されています',
  },
};

export const zipCodeValidator = {
  required: '郵便番号を入力してください',
  pattern: {
    value: /^[\d-]+$/,
    message: '郵便番号は数字とハイフンのみ許可されています',
  },
};
